import { createZenloopScriptTag } from '@/js/modules/external-services.js'

export const showOrderSurvey = ({ recipient, element, reloadWhenExisting, survey } = {}) => {
  if (!survey) {
    console.log(`Not loading Zenloop (no survey id: ${survey})`)
    return
  }

  window.Zenloop = window.Zenloop || {}
  window.Zenloop.isVisible = true
  window.Zenloop.recipient = recipient

  console.log('showOrderSurvey', { recipient })
  createZenloopScriptTag({
    survey,
    element,
    reloadWhenExisting,
  })
  return window.Zenloop
}

/**
Kauf
<script id="zl-website-overlay-loader" async src="https://zenloop-website-overlay-production.s3.amazonaws.com/loader/zenloop.load.min.js?survey=T0dGaVpHTXpNVEV0Tm1VM1lpMDBZMlprTFRnMFpXTXRNelUxTVdNM1pERXlOVGho"></script>

Standard Umfrage
<script id="zl-website-overlay-loader" async src="https://zenloop-website-overlay-production.s3.amazonaws.com/loader/zenloop.load.min.js?survey=TVdNNU1HSTVZbUV0WW1WaE55MDBOVE0zTFdJME56UXRNakkwTVRNM05qQXpZemho"></script>
 */
